import type { Ctx } from '@/core/context';
import { bus } from '@/core/bus';
import { nextRandom } from '@/core/rng';
import { bump } from './achievements';
import { gainXp } from './progress';
import { tr } from '@/i18n';

/** 地上的東西：每天依樓層的出生點隨機擺放 */
export function spawnGround(ctx: Ctx): void {
  const d = ctx.day; d.ground = []; d.bag = [];
  let n = 0;
  for (const f of ctx.c.floors) for (const p of f.pickups) if (nextRandom(d) < 0.8) d.ground.push({ uid: `g${n++}`, type: p.type, floor: f.id, pos: [p.pos[0], p.pos[1]] });
}

export function pickUp(ctx: Ctx, uid: string): void {
  const d = ctx.day; const g = d.ground.find(x => x.uid === uid); if (!g) return;
  const t = ctx.c.pickupById.get(g.type)!;
  if (d.bag.length >= 6) { ctx.ui.toast(tr("手上拿不下了，先去處理（丟垃圾桶、交給品保或送回去）。")); return; }
  d.ground = d.ground.filter(x => x.uid !== uid); d.bag.push(g.type);
  bus.emit('sfx', 'item'); bump(ctx, 'pickups'); gainXp(ctx, 'pickup');
  const how = { bin: tr("丟到垃圾桶（各樓層都有）"), report: tr("交給品保（小葉、Joyce）或工務（大熊）追查"), deliver: tr("送回該去的地方（標籤架／洗籃區）"), keep: tr("先收著") }[t.action];
  ctx.ui.card({ name: `${t.icon} ${t.name}`, role: tr("撿起來了"), color: '#f2b134', text: t.text,
    sections: [{ label: tr("該怎麼處理"), items: [how], tone: 'info' }, { label: tr("為什麼"), items: [t.lesson] }],
    choices: [{ text: tr("好"), fn: () => ctx.ui.close() }] });
  ctx.world.refreshActors(); ctx.save();
}

/** 在垃圾桶／標籤架／洗籃機／NPC 處理手上的東西。回傳處理了幾件 */
export function handleBag(ctx: Ctx, where: 'bin' | 'label' | 'basket' | 'report'): number {
  const d = ctx.day; let n = 0;
  const keep: string[] = [];
  for (const id of d.bag) {
    const t = ctx.c.pickupById.get(id)!;
    const ok = (where === 'bin' && t.action === 'bin') || (where === 'report' && t.action === 'report')
      || (where === 'label' && id === 'label-roll') || (where === 'basket' && id === 'basket-lid');
    if (!ok) { keep.push(id); continue; }
    n++;
    if (where === 'bin') { bump(ctx, 'binned'); ctx.apply({ records: 1 }, 'pickup'); }
    if (where === 'report') { bump(ctx, 'reported'); ctx.apply({ foodSafety: 3, records: 2 }, 'pickup'); gainXp(ctx, 'report'); }
    if (where === 'label' || where === 'basket') ctx.apply({ records: 2 }, 'pickup');
  }
  d.bag = keep;
  if (n) { bus.emit('sfx', 'ok'); ctx.save(); }
  return n;
}
